<template>
  <Notifications>
    <div
      class="main-mobile-header-notifications main-mobile-header-button"
      @click="handleOpen"
    >
      <NotificationsIcon class="main-mobile-header-icon" />
    </div>
  </Notifications>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import Notifications from '../../components/Notifications.vue'
import NotificationsIcon from '../../components/NotificationsIcon.vue'

import { useModalsStore } from '@/store/modals'
import MainMobileHeaderNotificationsPanel from './HeaderNotificationsPanel.vue'

const modalsStore = useModalsStore()

const handleOpen = () => {
  const modalInstance = modalsStore.init(
    'mobile-header-notifications',
    markRaw(MainMobileHeaderNotificationsPanel),
  )
  modalInstance?.open(modalsStore.getZIndex())
}
</script>

<style scoped>
.main-mobile-header-notifications {
  @apply -ml-12 mr-0.5;
}
</style>
